import {
  utils,
} from '@ama-sdk/core';
import {
  RegulatoryDetail,
  RegulatoryDetailsCategoryRequirement,
  RegulatoryDetailsReplyData,
} from '@dapi/sdk';
import {
  combineRegulatoryDetails,
  combineRegulatoryDetailsCategoryRequirements,
  combineRegulatoryDetailsRequirements,
  createRegulatoryDetailsReplyData,
  RegulatoryDetailRepository,
  RegulatoryDetailsCategoryRequirementRepository,
  todayPlusNdays,
} from '@dapi/sdk/spec';
import {
  travelers,
} from './journey-logic';

let missingDetails: RegulatoryDetailsCategoryRequirement[];
let storedDetails: RegulatoryDetail[];
let travelerId: string;

export const regulatoriesFirstPax: RegulatoryDetailsReplyData[] = [];
export const regulatoriesSecondPax: RegulatoryDetailsReplyData[] = [];

/**
 * Init regulatory details items for traveler
 *
 * @param id traveler id
 */
function initRegulatory(id: string) {
  missingDetails = combineRegulatoryDetailsCategoryRequirements([
    {
      isOptional: false,
      detailsCategory: 'personalDetails',
      detailsChoices: combineRegulatoryDetailsRequirements([
        {
          canBeDeclined: false,
          requiredDetailsFields: ['gender', 'birthDate', 'nationalityCountryCode', 'countryOfResidence']
        }
      ]).items
    },
    RegulatoryDetailsCategoryRequirementRepository.MISSING_TSA
  ]).items;

  storedDetails = [RegulatoryDetailRepository.STORED_TSA];

  travelerId = id;
}

export const regulatories: RegulatoryDetailsReplyData[] = [];

/**
 * Add Regulatory for first passenger
 */
function addRegulatory() {
  regulatoriesFirstPax.push(
    createRegulatoryDetailsReplyData({
      template: {
        ...regulatoriesFirstPax.at(-1),
        storedDetails,
        missingDetails,
        travelerId
      }
    }) as RegulatoryDetailsReplyData
  );
}

/**
 * Add Regulatory for second passenger
 */
function addRegulatorySecondPax() {
  regulatoriesSecondPax.push(
    createRegulatoryDetailsReplyData({
      template: {
        ...regulatoriesSecondPax.at(-1),
        storedDetails,
        missingDetails,
        travelerId
      }
    })
  );
}

initRegulatory('JOURNEY-TRAVELER-0-MOCK');

addRegulatory();

storedDetails = combineRegulatoryDetails([RegulatoryDetailRepository.STORED_TSA, {
  personalDetails: {
    nationalityCode: 'IND'
  }
}]).items;

missingDetails = combineRegulatoryDetailsCategoryRequirements([
  {
    isOptional: false,
    detailsCategory: 'personalDetails',
    detailsChoices: combineRegulatoryDetailsRequirements([{
      canBeDeclined: false,
      requiredDetailsFields: ['countryOfResidence']
    }]).items
  }
]).items;

addRegulatory();

storedDetails = combineRegulatoryDetails([
  RegulatoryDetailRepository.STORED_TSA,
  {
    personalDetails: {
      nationalityCode: 'IND',
      countryOfResidence: 'United States',
      countryOfResidenceCode: 'US'
    }
  }
]).items;

missingDetails = combineRegulatoryDetailsCategoryRequirements([
  {
    isOptional: false,
    detailsCategory: 'personalDetails',
    detailsChoices: combineRegulatoryDetailsRequirements([{
      canBeDeclined: false,
      requiredDetailsFields: ['gender', 'birthDate']
    }]).items
  }
]).items;

addRegulatory();

storedDetails = combineRegulatoryDetails([
  RegulatoryDetailRepository.STORED_TSA,
  {
    personalDetails: {
      nationalityCode: 'IND',
      countryOfResidence: 'United States',
      countryOfResidenceCode: 'US'
    }
  }
]).items;

missingDetails = combineRegulatoryDetailsCategoryRequirements([
  {
    isOptional: false,
    detailsCategory: 'identityDocument',
    detailsChoices: combineRegulatoryDetailsRequirements([
      {
        detailsType: 'document',
        regulatoryType: 'passport'
      },
      {
        detailsType: 'document',
        regulatoryType: 'identityCard'
      }
    ]).items
  }
]).items;

addRegulatory();

storedDetails = combineRegulatoryDetails([
  RegulatoryDetailRepository.STORED_TSA,
  {
    personalDetails: {
      nationalityCode: 'IND',
      countryOfResidence: 'United States',
      countryOfResidenceCode: 'US'
    }
  },
  {
    document: {
      documentType: 'passport',
      expiryDate: new utils.Date(todayPlusNdays('09:00', 370)),
      issuanceCountryCode: 'IN',
      nationalityCode: 'IND',
      name: travelers[1].names[0],
      number: '1111222233334444'
    }
  }
]).items;

missingDetails = combineRegulatoryDetailsCategoryRequirements([
  {
    isOptional: false,
    detailsCategory: 'greenCard',
    detailsChoices: combineRegulatoryDetailsRequirements([
      {
        detailsType: 'document',
        regulatoryType: 'residentAlienCard',
        requiredDetailsFields: ['number', 'nationalityCountryCode', 'expiryDate', 'issuanceCountry'],
        canBeDeclined: false
      },
      {
        detailsType: 'document',
        regulatoryType: 'permanentResidentCard',
        requiredDetailsFields: ['number', 'nationalityCountryCode', 'expiryDate', 'issuanceCountry'],
        canBeDeclined: false
      }
    ]).items
  },
  {
    isOptional: false,
    detailsCategory: 'emergencyContact',
    detailsChoices: combineRegulatoryDetailsRequirements([
      {
        detailsType: 'phone',
        regulatoryType: 'emergencyContact',
        requiredDetailsFields: ['name', 'nationalityCountryCode', 'countryPhoneExtension', 'number'],
        canBeDeclined: true
      }
    ]).items
  },
  {
    isOptional: false,
    detailsCategory: 'destinationAddress',
    detailsChoices: combineRegulatoryDetailsRequirements([
      {
        detailsType: 'address',
        regulatoryType: 'destinationAddress',
        requiredDetailsFields: ['nationalityCountryCode', 'zipCode', 'stateCode', 'cityName', 'lines'],
        canBeDeclined: false
      }
    ]).items
  },
  {
    isOptional: false,
    detailsCategory: 'personalDetails',
    detailsChoices: combineRegulatoryDetailsRequirements([
      {
        detailsType: 'personalDetails',
        regulatoryType: 'personalDetails',
        requiredDetailsFields: ['purposeOfVisit'],
        canBeDeclined: false
      }
    ]).items
  }
]).items;

addRegulatory();

storedDetails = combineRegulatoryDetails([
  RegulatoryDetailRepository.STORED_TSA,
  {
    personalDetails: {
      nationalityCode: 'IND',
      countryOfResidence: 'United States',
      countryOfResidenceCode: 'US'
    }
  },
  {
    document: {
      documentType: 'passport',
      expiryDate: new utils.Date(todayPlusNdays('09:00', 370)),
      issuanceCountryCode: 'IN',
      nationalityCode: 'IND',
      name: travelers[1].names[0],
      number: '1111222233334444'
    }
  },
  {
    document: {
      documentType: 'permanentResidentCard',
      expiryDate: new utils.Date(todayPlusNdays('09:00', 370)),
      issuanceDate: new utils.Date(todayPlusNdays('09:00', -370)),
      issuanceCountryCode: 'US',
      nationalityCode: 'IND',
      name: travelers[1].names[0],
      number: 'PRC11223344'
    }
  }
]).items;

missingDetails = combineRegulatoryDetailsCategoryRequirements([
  {
    isOptional: false,
    detailsCategory: 'emergencyContact',
    detailsChoices: combineRegulatoryDetailsRequirements([
      {
        detailsType: 'phone',
        regulatoryType: 'emergencyContact',
        requiredDetailsFields: ['name', 'nationalityCountryCode', 'countryPhoneExtension', 'number'],
        canBeDeclined: true
      }
    ]).items
  },
  {
    isOptional: false,
    detailsCategory: 'destinationAddress',
    detailsChoices: combineRegulatoryDetailsRequirements([
      {
        detailsType: 'address',
        regulatoryType: 'destinationAddress',
        requiredDetailsFields: ['nationalityCountryCode', 'zipCode', 'stateCode', 'cityName', 'lines'],
        canBeDeclined: false
      }
    ]).items
  },
  {
    isOptional: false,
    detailsCategory: 'personalDetails',
    detailsChoices: combineRegulatoryDetailsRequirements([
      {
        detailsType: 'personalDetails',
        regulatoryType: 'personalDetails',
        requiredDetailsFields: ['purposeOfVisit'],
        canBeDeclined: false
      }
    ]).items
  }
]).items;

addRegulatory();

storedDetails = combineRegulatoryDetails([
  RegulatoryDetailRepository.STORED_TSA,
  {
    personalDetails: {
      nationalityCode: 'IND',
      countryOfResidence: 'United States',
      countryOfResidenceCode: 'US'
    }
  },
  {
    document: {
      documentType: 'passport',
      expiryDate: new utils.Date(todayPlusNdays('09:00', 370)),
      issuanceCountryCode: 'IN',
      nationalityCode: 'IND',
      name: travelers[1].names[0],
      number: '1111222233334444'
    }
  },
  {
    document: {
      documentType: 'permanentResidentCard',
      expiryDate: new utils.Date(todayPlusNdays('09:00', 370)),
      issuanceDate: new utils.Date(todayPlusNdays('09:00', -370)),
      issuanceCountryCode: 'US',
      nationalityCode: 'IND',
      name: travelers[1].names[0],
      number: 'PRC11223344'
    }
  },
  {
    address: {
      cityName: 'MONTGOMERY',
      lines: ['ADDRESS 1'],
      zipCode: '06700',
      countryCode: 'US',
      stateCode: 'AL',
      type: 'destinationAddress'
    }
  }
]).items;

missingDetails = combineRegulatoryDetailsCategoryRequirements([
  {
    isOptional: false,
    detailsCategory: 'emergencyContact',
    detailsChoices: combineRegulatoryDetailsRequirements([
      {
        detailsType: 'phone',
        regulatoryType: 'emergencyContact',
        requiredDetailsFields: ['name', 'nationalityCountryCode', 'countryPhoneExtension', 'number'],
        canBeDeclined: true
      }
    ]).items
  },
  {
    isOptional: false,
    detailsCategory: 'personalDetails',
    detailsChoices: combineRegulatoryDetailsRequirements([
      {
        detailsType: 'personalDetails',
        regulatoryType: 'personalDetails',
        requiredDetailsFields: ['purposeOfVisit'],
        canBeDeclined: false
      }
    ]).items
  }
]).items;

addRegulatory();

storedDetails = combineRegulatoryDetails([
  RegulatoryDetailRepository.STORED_TSA,
  {
    personalDetails: {
      nationalityCode: 'IND',
      countryOfResidence: 'United States',
      countryOfResidenceCode: 'US'
    }
  },
  {
    document: {
      documentType: 'passport',
      expiryDate: new utils.Date(todayPlusNdays('09:00', 370)),
      issuanceCountryCode: 'IN',
      nationalityCode: 'IND',
      name: travelers[1].names[0],
      number: '1111222233334444'
    }
  },
  {
    document: {
      documentType: 'permanentResidentCard',
      expiryDate: new utils.Date(todayPlusNdays('09:00', 370)),
      issuanceDate: new utils.Date(todayPlusNdays('09:00', -370)),
      issuanceCountryCode: 'US',
      nationalityCode: 'IND',
      name: travelers[1].names[0],
      number: 'PRC11223344'
    }
  },
  {
    address: {
      cityName: 'MONTGOMERY',
      lines: ['ADDRESS 1'],
      zipCode: '06700',
      countryCode: 'US',
      stateCode: 'AL',
      type: 'destinationAddress'
    }
  }
]).items;

missingDetails = combineRegulatoryDetailsCategoryRequirements([
  {
    isOptional: false,
    detailsCategory: 'personalDetails',
    detailsChoices: combineRegulatoryDetailsRequirements([
      {
        detailsType: 'personalDetails',
        regulatoryType: 'personalDetails',
        requiredDetailsFields: ['purposeOfVisit'],
        canBeDeclined: false
      }
    ]).items
  }
]).items;

addRegulatory();

const lastRegulatoryFirstPax = regulatoriesFirstPax.at(-1);
if (lastRegulatoryFirstPax) {
  lastRegulatoryFirstPax.declinedDetails = ['emergencyContact'];
}

storedDetails = combineRegulatoryDetails([
  RegulatoryDetailRepository.STORED_TSA,
  {
    personalDetails: {
      nationalityCode: 'IND',
      countryOfResidence: 'United States',
      countryOfResidenceCode: 'US',
      purposeOfVisit: 'work'
    }
  },
  {
    document: {
      documentType: 'passport',
      expiryDate: new utils.Date(todayPlusNdays('09:00', 370)),
      issuanceCountryCode: 'IN',
      nationalityCode: 'IND',
      name: travelers[1].names[0],
      number: '1111222233334444'
    }
  },
  {
    document: {
      documentType: 'permanentResidentCard',
      expiryDate: new utils.Date(todayPlusNdays('09:00', 370)),
      issuanceDate: new utils.Date(todayPlusNdays('09:00', -370)),
      issuanceCountryCode: 'US',
      nationalityCode: 'IND',
      name: travelers[1].names[0],
      number: 'PRC11223344'
    }
  },
  {
    address: {
      cityName: 'MONTGOMERY',
      lines: ['ADDRESS 1'],
      zipCode: '06700',
      countryCode: 'US',
      stateCode: 'AL',
      type: 'destinationAddress'
    }
  }
]).items;

missingDetails = [];

addRegulatory();

/*
* Regulatory calls for the second pax
*/

initRegulatory('JOURNEY-TRAVELER-1-MOCK');

addRegulatorySecondPax();

storedDetails = combineRegulatoryDetails([RegulatoryDetailRepository.STORED_TSA, {
  personalDetails: {
    nationalityCode: 'IND'
  }
}]).items;

missingDetails = combineRegulatoryDetailsCategoryRequirements([
  {
    isOptional: false,
    detailsCategory: 'personalDetails',
    detailsChoices: combineRegulatoryDetailsRequirements([{
      canBeDeclined: false,
      requiredDetailsFields: ['countryOfResidence']
    }]).items
  }
]).items;
addRegulatorySecondPax();

storedDetails = combineRegulatoryDetails([
  RegulatoryDetailRepository.STORED_TSA,
  {
    personalDetails: {
      nationalityCode: 'IND',
      countryOfResidence: 'United States',
      countryOfResidenceCode: 'US'
    }
  }
]).items;

missingDetails = combineRegulatoryDetailsCategoryRequirements([
  {
    isOptional: false,
    detailsCategory: 'personalDetails',
    detailsChoices: combineRegulatoryDetailsRequirements([{
      canBeDeclined: false,
      requiredDetailsFields: ['gender', 'birthDate']
    }]).items
  }
]).items;

addRegulatorySecondPax();

storedDetails = combineRegulatoryDetails([
  RegulatoryDetailRepository.STORED_TSA,
  {
    personalDetails: {
      nationalityCode: 'IND',
      countryOfResidence: 'United States',
      countryOfResidenceCode: 'US'
    }
  }
]).items;

missingDetails = combineRegulatoryDetailsCategoryRequirements([
  {
    isOptional: false,
    detailsCategory: 'identityDocument',
    detailsChoices: combineRegulatoryDetailsRequirements([
      {
        detailsType: 'document',
        regulatoryType: 'passport'
      },
      {
        detailsType: 'document',
        regulatoryType: 'identityCard'
      }
    ]).items
  }
]).items;

addRegulatorySecondPax();

storedDetails = combineRegulatoryDetails([
  RegulatoryDetailRepository.STORED_TSA,
  {
    personalDetails: {
      nationalityCode: 'IND',
      countryOfResidence: 'United States',
      countryOfResidenceCode: 'US'
    }
  },
  {
    document: {
      documentType: 'passport',
      expiryDate: new utils.Date(todayPlusNdays('09:00', 370)),
      issuanceCountryCode: 'IN',
      nationalityCode: 'IND',
      name: travelers[1].names[0],
      number: '0000111122223333'
    }
  }
]).items;

missingDetails = combineRegulatoryDetailsCategoryRequirements([
  {
    isOptional: false,
    detailsCategory: 'greenCard',
    detailsChoices: combineRegulatoryDetailsRequirements([
      {
        detailsType: 'document',
        regulatoryType: 'residentAlienCard',
        requiredDetailsFields: ['number', 'nationalityCountryCode', 'expiryDate', 'issuanceCountry'],
        canBeDeclined: false
      },
      {
        detailsType: 'document',
        regulatoryType: 'permanentResidentCard',
        requiredDetailsFields: ['number', 'nationalityCountryCode', 'expiryDate', 'issuanceCountry'],
        canBeDeclined: false
      }
    ]).items
  },
  {
    isOptional: false,
    detailsCategory: 'emergencyContact',
    detailsChoices: combineRegulatoryDetailsRequirements([
      {
        detailsType: 'phone',
        regulatoryType: 'emergencyContact',
        requiredDetailsFields: ['name', 'nationalityCountryCode', 'countryPhoneExtension', 'number'],
        canBeDeclined: true
      }
    ]).items
  },
  {
    isOptional: false,
    detailsCategory: 'destinationAddress',
    detailsChoices: combineRegulatoryDetailsRequirements([
      {
        detailsType: 'address',
        regulatoryType: 'destinationAddress',
        requiredDetailsFields: ['nationalityCountryCode', 'zipCode', 'stateCode', 'cityName', 'lines'],
        canBeDeclined: false
      }
    ]).items
  },
  {
    isOptional: false,
    detailsCategory: 'personalDetails',
    detailsChoices: combineRegulatoryDetailsRequirements([
      {
        detailsType: 'personalDetails',
        regulatoryType: 'personalDetails',
        requiredDetailsFields: ['purposeOfVisit'],
        canBeDeclined: false
      }
    ]).items
  }
]).items;

addRegulatorySecondPax();

storedDetails = combineRegulatoryDetails([
  RegulatoryDetailRepository.STORED_TSA,
  {
    personalDetails: {
      nationalityCode: 'IND',
      countryOfResidence: 'United States',
      countryOfResidenceCode: 'US'
    }
  },
  {
    document: {
      documentType: 'passport',
      expiryDate: new utils.Date(todayPlusNdays('09:00', 370)),
      issuanceCountryCode: 'IN',
      nationalityCode: 'IND',
      name: travelers[1].names[0],
      number: '1111222233334444'
    }
  },
  {
    document: {
      documentType: 'residentAlienCard',
      expiryDate: new utils.Date(todayPlusNdays('09:00', 370)),
      issuanceDate: new utils.Date(todayPlusNdays('09:00', -370)),
      issuanceCountryCode: 'US',
      nationalityCode: 'IND',
      name: travelers[1].names[0],
      number: 'RAL11223344'
    }
  }
]).items;

missingDetails = combineRegulatoryDetailsCategoryRequirements([
  {
    isOptional: false,
    detailsCategory: 'emergencyContact',
    detailsChoices: combineRegulatoryDetailsRequirements([
      {
        detailsType: 'phone',
        regulatoryType: 'emergencyContact',
        requiredDetailsFields: ['name', 'nationalityCountryCode', 'countryPhoneExtension', 'number'],
        canBeDeclined: true
      }
    ]).items
  },
  {
    isOptional: false,
    detailsCategory: 'destinationAddress',
    detailsChoices: combineRegulatoryDetailsRequirements([
      {
        detailsType: 'address',
        regulatoryType: 'destinationAddress',
        requiredDetailsFields: ['nationalityCountryCode', 'zipCode', 'stateCode', 'cityName', 'lines'],
        canBeDeclined: false
      }
    ]).items
  },
  {
    isOptional: false,
    detailsCategory: 'personalDetails',
    detailsChoices: combineRegulatoryDetailsRequirements([
      {
        detailsType: 'personalDetails',
        regulatoryType: 'personalDetails',
        requiredDetailsFields: ['purposeOfVisit'],
        canBeDeclined: false
      }
    ]).items
  }
]).items;

addRegulatorySecondPax();

storedDetails = combineRegulatoryDetails([
  RegulatoryDetailRepository.STORED_TSA,
  {
    personalDetails: {
      nationalityCode: 'IND',
      countryOfResidence: 'United States',
      countryOfResidenceCode: 'US'
    }
  },
  {
    document: {
      documentType: 'passport',
      expiryDate: new utils.Date(todayPlusNdays('09:00', 370)),
      issuanceCountryCode: 'IN',
      nationalityCode: 'IND',
      name: travelers[1].names[0],
      number: '1111222233334444'
    }
  },
  {
    document: {
      documentType: 'permanentResidentCard',
      expiryDate: new utils.Date(todayPlusNdays('09:00', 370)),
      issuanceDate: new utils.Date(todayPlusNdays('09:00', -370)),
      issuanceCountryCode: 'US',
      nationalityCode: 'IND',
      name: travelers[1].names[0],
      number: 'PRC11223344'
    }
  },
  {
    address: {
      cityName: 'MONTGOMERY',
      lines: ['ADDRESS 1'],
      zipCode: '06700',
      countryCode: 'US',
      stateCode: 'AL',
      type: 'destinationAddress'
    }
  }
]).items;

missingDetails = combineRegulatoryDetailsCategoryRequirements([
  {
    isOptional: false,
    detailsCategory: 'emergencyContact',
    detailsChoices: combineRegulatoryDetailsRequirements([
      {
        detailsType: 'phone',
        regulatoryType: 'emergencyContact',
        requiredDetailsFields: ['name', 'nationalityCountryCode', 'countryPhoneExtension', 'number'],
        canBeDeclined: true
      }
    ]).items
  },
  {
    isOptional: false,
    detailsCategory: 'personalDetails',
    detailsChoices: combineRegulatoryDetailsRequirements([
      {
        detailsType: 'personalDetails',
        regulatoryType: 'personalDetails',
        requiredDetailsFields: ['purposeOfVisit'],
        canBeDeclined: false
      }
    ]).items
  }
]).items;

addRegulatorySecondPax();

storedDetails = combineRegulatoryDetails([
  RegulatoryDetailRepository.STORED_TSA,
  {
    personalDetails: {
      nationalityCode: 'IND',
      countryOfResidence: 'United States',
      countryOfResidenceCode: 'US'
    }
  },
  {
    document: {
      documentType: 'passport',
      expiryDate: new utils.Date(todayPlusNdays('09:00', 370)),
      issuanceCountryCode: 'IN',
      nationalityCode: 'IND',
      name: travelers[1].names[0],
      number: '1111222233334444'
    }
  },
  {
    document: {
      documentType: 'permanentResidentCard',
      expiryDate: new utils.Date(todayPlusNdays('09:00', 370)),
      issuanceDate: new utils.Date(todayPlusNdays('09:00', -370)),
      issuanceCountryCode: 'US',
      nationalityCode: 'IND',
      name: travelers[1].names[0],
      number: 'PRC11223344'
    }
  },
  {
    address: {
      cityName: 'MONTGOMERY',
      lines: ['ADDRESS 1'],
      zipCode: '06700',
      countryCode: 'US',
      stateCode: 'AL',
      type: 'destinationAddress'
    }
  },
  {
    phoneNumber: {
      purpose: 'emergencyContact',
      countryCode: 'US',
      countryPhoneExtension: 'US',
      name: {
        lastName: 'Gency'
      },
      number: '1234567890'
    }
  }
]).items;

missingDetails = combineRegulatoryDetailsCategoryRequirements([
  {
    isOptional: false,
    detailsCategory: 'personalDetails',
    detailsChoices: combineRegulatoryDetailsRequirements([
      {
        detailsType: 'personalDetails',
        regulatoryType: 'personalDetails',
        requiredDetailsFields: ['purposeOfVisit'],
        canBeDeclined: false
      }
    ]).items
  }
]).items;

addRegulatorySecondPax();

storedDetails = combineRegulatoryDetails([
  RegulatoryDetailRepository.STORED_TSA,
  {
    personalDetails: {
      nationalityCode: 'IND',
      countryOfResidence: 'United States',
      countryOfResidenceCode: 'US',
      purposeOfVisit: 'work'
    }
  },
  {
    document: {
      documentType: 'passport',
      expiryDate: new utils.Date(todayPlusNdays('09:00', 370)),
      issuanceCountryCode: 'IN',
      nationalityCode: 'IND',
      name: travelers[1].names[0],
      number: '1111222233334444'
    }
  },
  {
    document: {
      documentType: 'permanentResidentCard',
      expiryDate: new utils.Date(todayPlusNdays('09:00', 370)),
      issuanceDate: new utils.Date(todayPlusNdays('09:00', -370)),
      issuanceCountryCode: 'US',
      nationalityCode: 'IND',
      name: travelers[1].names[0],
      number: 'PRC11223344'
    }
  },
  {
    address: {
      cityName: 'MONTGOMERY',
      lines: ['ADDRESS 1'],
      zipCode: '06700',
      countryCode: 'US',
      stateCode: 'AL',
      type: 'destinationAddress'
    }
  },
  {
    phoneNumber: {
      purpose: 'emergencyContact',
      countryCode: 'US',
      countryPhoneExtension: 'US',
      name: {
        lastName: 'Gency'
      },
      number: '1234567890'
    }
  }
]).items;

missingDetails = [];

addRegulatorySecondPax();

export const [getRegulatoryDetailsFirstPax, ...addRegulatoryDetailsFirstPax] = regulatoriesFirstPax;
export const [getRegulatoryDetailsSecondPax, ...addRegulatoryDetailsSecondPax] = regulatoriesSecondPax;
export const getRegulatoryDetailsFirstPaxCompleted = regulatoriesFirstPax.at(-1);
export const getRegulatoryDetailsSecondPaxCompleted = regulatoriesSecondPax.at(-1);
